export const reportingEn = {
  reporting: {
    nav: {
      listingsEngagement: 'Listings Engagement',
      leads: {
        title: 'Leads',
        totalLeads: {
          title: 'Total Leads',
          overview: 'Overview',
          byDay: 'By Day',
          byProperty: 'By Property',
          byCity: 'By City',
          bySource: 'By Source',
        },
        listingSiteLeads: {
          title: 'Listing Site Leads',
          overview: 'Overview',
          bySource: 'By Source',
          recentTrends: 'Recent Trends',
          infinity: 'Infinity',
        },
        websiteLeads: {
          title: 'Website Leads',
          overview: 'Overview',
          referralSources: 'Referral Sources',
          phoneCalls: 'Phone Calls',
        },
      },
      callTracking: {
        title: 'Call Tracking',
        overview: 'Overview',
        callsBySource: 'Calls By Source',
        callsByProperty: 'Calls By Property',
        callDuration: 'Call Duration',
        peakUsage: 'Peak Usage',
      },
      websites: {
        title: 'Websites',
        overview: 'Overview',
        traffic: 'Traffic',
        devices: 'Devices',
        events: 'Events',
      },
      floorplanNavigator: 'Floorplan Navigator',
      tours: 'Tours',
      digitalMarketing: {
        title: 'Digital Marketing',
        googleAds: 'Google Ads',
      },
      listingScores: 'Listing Scores',
      customReporting: 'Custom Reporting',
    },

    breadcrumbs: {
      root: 'Reporting',
      leads: 'Leads',
      totalLeads: 'Total Leads',
      listingSiteLeads: 'Listing Site Leads',
      websiteLeads: 'Website Leads',
      website: 'Website',
      callTracking: 'Call Tracking',
      marketing: 'Marketing',
    },

    views: {
      totalLeadsOverview: {
        dashboardTitle: 'Total Leads Overview',
        routeTitle: 'Leads Overview',
        breadcrumbLeaf: 'Overview',
      },
      totalLeadsByDay: {
        dashboardTitle: 'Total Leads By Day',
        routeTitle: 'Total Leads By Day',
        breadcrumbLeaf: 'By Day',
      },
      totalLeadsByDayOfWeek: {
        dashboardTitle: 'Total Leads by Day Of Week',
        routeTitle: 'Total Leads by Day of Week',
        breadcrumbLeaf: 'By Day of Week',
      },
      totalLeadsByHourOfDay: {
        dashboardTitle: 'Total Leads by Hour of Day',
        routeTitle: 'Total Leads by Hour of Day',
        breadcrumbLeaf: 'By Hour of Day',
      },
      totalLeadsAvgLeadProperty: {
        dashboardTitle: 'Average Leads per Active Property per Day',
        routeTitle: 'Average Leads per Active Property per Day',
        breadcrumbLeaf: 'Average Per Property Per Day',
      },
      totalLeadsByProperty: {
        dashboardTitle: 'Total Leads by Property',
        routeTitle: 'Total Leads by Property',
        breadcrumbLeaf: 'By Property',
      },
      totalLeadsByPropertyType: {
        dashboardTitle: 'Total Leads by Property Type',
        routeTitle: 'Total Leads by Property Type',
        breadcrumbLeaf: 'By Property Type',
      },
      totalLeadsByCity: {
        dashboardTitle: 'Total Leads by City',
        routeTitle: 'Total Leads by City',
        breadcrumbLeaf: 'By City',
      },
      totalLeadsByCityPerProperty: {
        dashboardTitle: 'Average Leads Per Property By City',
        routeTitle: 'Average Leads Per Property By City',
        breadcrumbLeaf: 'By City Per Property',
      },
      totalLeadsBySourceProperty: {
        dashboardTitle: 'Average Leads per Active Property by Source',
        routeTitle: 'Average Leads per Active Property by Source',
        breadcrumbLeaf: 'Per Property By Source',
      },
      totalLeadsBySourceDay: {
        dashboardTitle: 'Per Property by Source by Day',
        routeTitle: 'Per Property by Source by Day',
        breadcrumbLeaf: 'Per Property by Source by Day',
      },
      siteLeadsBySource: {
        dashboardTitle: 'Listing Site Leads by Source',
        routeTitle: 'By Source',
      },
      siteLeadsOverview: {
        dashboardTitle: 'Listing Site Leads Overview',
        routeTitle: 'Overview',
      },
      siteLeadsAdTrend: {
        dashboardTitle: 'Recent Trends',
        routeTitle: 'Recent Trends',
      },
      siteLeadsInfinity: {
        dashboardTitle: 'Leads Infinity',
        routeTitle: 'Infinity',
      },
      leadsWebsiteOverview: {
        dashboardTitle: 'Website Leads Overview',
        routeTitle: 'Overview',
      },
      leadsWebsiteReferral: {
        dashboardTitle: 'Referral Source by Website Leads',
        routeTitle: 'Referral Sources',
      },
      leadsWebsiteDevices: {
        dashboardTitle: 'Website Traffic Device Breakdown',
        routeTitle: 'Website Devices',
      },
      floorplanNavigator: {
        dashboardTitle: 'Floorplan Navigator',
        routeTitle: 'Floorplan Navigator',
      },
      leadsWebsiteCallReport: {
        dashboardTitle: 'Call Report',
        routeTitle: 'Call Report',
      },
      callTrackingOverview: {
        dashboardTitle: 'Call Tracking Overview',
        routeTitle: 'Overview',
      },
      callTrackingCallsBySource: {
        dashboardTitle: 'Calls by Source',
        routeTitle: 'Calls By Source',
      },
      callTrackingCallsByProperty: {
        dashboardTitle: 'Calls by Property',
        routeTitle: 'Calls By Property',
      },
      callTrackingDuration: {
        dashboardTitle: 'Call Duration',
        routeTitle: 'Call Duration',
      },
      callTrackingUsage: {
        dashboardTitle: 'Peak Usage',
        routeTitle: 'Peak Usage',
      },
      tours: {
        dashboardTitle: 'Tours',
        routeTitle: 'Tours',
      },
      websitesLeads: {
        dashboardTitle: 'Website Overview',
        routeTitle: 'Overview',
      },
      websitesTraffic: {
        dashboardTitle: 'Website Traffic Overview',
        routeTitle: 'Website Traffic',
      },
      websitesEvents: {
        dashboardTitle: 'Website Events',
        routeTitle: 'Website Events',
      },
      googleAds: {
        dashboardTitle: 'Google Ads',
        routeTitle: 'Google Ads',
      },
      listingScores: {
        dashboardTitle: 'Listing Scores',
        routeTitle: 'Listing Scores',
      },
      customReporting: {
        routeTitle: 'Custom Reporting',
      },
      listingEngagements: {
        dashboardTitle: 'Listings Engagement',
        routeTitle: 'Listings Engagement',
      },
    },

    titleBar: {
      exportToExcel: 'Export To Excel',
      exportToPdf: 'Export to PDF',
      filterReports: 'Filter Reports ({count})',
      exportExcelSuccess: 'Exported to Excel.',
      exportExcelError: 'Error exporting to Excel.',
    },

    sidebarFilters: {
      defaultTitle: 'Filters',
      learnMore: 'Learn More',
      maxCount: '(Max {max})',
      selectedCountParens: '({count})',
      showMore: 'SHOW MORE',
      reset: 'Reset',
      clear: 'Clear',
      resetFilters: 'Reset Filters',
      applyFilters: 'Apply Filters',
      singleValueRequired: 'A value is required for filtering!',
      multiValueRequired: 'At least one selection is required for filtering!',
      lockedTooltip: 'Advanced filters are only available with full access.',
      filtersAppliedCount: '({count} Filter Applied) | ({count} Filters Applied)',
    },

    filters: {
      dates: {
        label: 'Dates',
      },
      sources: {
        label: 'Sources',
      },
      buildings: {
        label: 'Properties',
      },
      propertyType: {
        label: 'Property Type',
      },
      cities: {
        label: 'Cities',
        helpText: 'Select one or more cities to filter the report.',
      },
      websites: {
        label: 'Active Websites',
      },
      ownershipGroups: {
        label: 'Ownership Groups',
      },
      agents: {
        label: 'Agents',
      },
      adCampaigns: {
        label: 'Ad Campaigns',
      },
      fpnSites: {
        label: 'Active FPNs',
      },
    },

    customReporting: {
      stats: {
        yearsTitle: '12+ Years',
        yearsSubtitle: 'Industry Experience',
        propertiesTitle: '22,000+',
        propertiesSubtitle: 'Active Properties',
        unitsTitle: '100,000+',
        unitsSubtitle: 'Active Units',
        leadsTitle: '250,000+',
        leadsSubtitle: 'Leads Monthly',
        queriesTitle: '15,000,000+',
        queriesSubtitle: 'Queries Monthly',
      },
      about: {
        title: 'About Rentsync\'s Custom Reports',
        contentTitle: 'Tracking multifamily market trends can be time consuming and complex.',
        bodyParagraph1: 'Rentsync aims to make it quick and easy for you to understand where the markets are and where they\'re headed, with our custom multifamily and renter insight data reports.',
        bodyParagraph2: 'We house a vast collection of multifamily data ranging from market conditions, to new construction, renter traffic and more, providing the most accurate and detailed data for review.',
        bodyParagraph3: 'With easy-to-read graphs and charts tailor-made to the metrics you’re looking for, and by adding on our in-house analysis summary, each report is delivered in a downloadable, digital format that is easy to read and share with your team.',
        bodyParagraph4: 'Whether you’re building a new property, updating an existing one or want to locate your position in the market, Rentsync’s Custom Reports can help you make more informed decisions and stay on top of current market trends.',
        bodyParagraph5: 'All reports are available for purchase. Please submit your requests below and a Rentsync team member will reach out with the next steps.',
      },
      reportTypesHeader: 'Custom Report Types',
      reportTypes: {
        leadReport: 'Lead Report',
        rentersInsightReport: 'Renters Insight Report',
        marketSurveyReport: 'Market Survey Report',
        marketComparisonReport: 'Market Comparison Report',
        fullCustomReport: 'Full Custom Report',
      },
      requestReportButton: 'Request Report',
    },
  },
} as const;

export const reportingFr = {
  reporting: {
    nav: {
      listingsEngagement: 'Engagement des annonces',
      leads: {
        title: 'Prospects',
        totalLeads: {
          title: 'Total des prospects',
          overview: 'Aperçu',
          byDay: 'Par jour',
          byProperty: 'Par propriété',
          byCity: 'Par ville',
          bySource: 'Par source',
        },
        listingSiteLeads: {
          title: 'Prospects du site d\'annonces',
          overview: 'Aperçu',
          bySource: 'Par source',
          recentTrends: 'Tendances récentes',
          infinity: 'Infinity',
        },
        websiteLeads: {
          title: 'Prospects du site web',
          overview: 'Aperçu',
          referralSources: 'Sources de référence',
          phoneCalls: 'Appels téléphoniques',
        },
      },
      callTracking: {
        title: 'Suivi des appels',
        overview: 'Aperçu',
        callsBySource: 'Appels par source',
        callsByProperty: 'Appels par propriété',
        callDuration: 'Durée des appels',
        peakUsage: 'Utilisation de pointe',
      },
      websites: {
        title: 'Sites web',
        overview: 'Aperçu',
        traffic: 'Trafic',
        devices: 'Appareils',
        events: 'Événements',
      },
      floorplanNavigator: 'Navigateur de plans d\'étage',
      tours: 'Visites',
      digitalMarketing: {
        title: 'Marketing numérique',
        googleAds: 'Google Ads',
      },
      listingScores: 'Cotes des annonces',
      customReporting: 'Rapports personnalisés',
    },

    breadcrumbs: {
      root: 'Rapports',
      leads: 'Prospects',
      totalLeads: 'Total des prospects',
      listingSiteLeads: 'Prospects du site d\'annonces',
      websiteLeads: 'Prospects du site web',
      website: 'Site web',
      callTracking: 'Suivi des appels',
      marketing: 'Marketing',
    },

    views: {
      totalLeadsOverview: {
        dashboardTitle: 'Aperçu du total des prospects',
        routeTitle: 'Aperçu des prospects',
        breadcrumbLeaf: 'Aperçu',
      },
      totalLeadsByDay: {
        dashboardTitle: 'Total des prospects par jour',
        routeTitle: 'Total des prospects par jour',
        breadcrumbLeaf: 'Par jour',
      },
      totalLeadsByDayOfWeek: {
        dashboardTitle: 'Total des prospects par jour de la semaine',
        routeTitle: 'Total des prospects par jour de la semaine',
        breadcrumbLeaf: 'Par jour de la semaine',
      },
      totalLeadsByHourOfDay: {
        dashboardTitle: 'Total des prospects par heure de la journée',
        routeTitle: 'Total des prospects par heure de la journée',
        breadcrumbLeaf: 'Par heure de la journée',
      },
      totalLeadsAvgLeadProperty: {
        dashboardTitle: 'Moyenne de prospects par propriété active par jour',
        routeTitle: 'Moyenne de prospects par propriété active par jour',
        breadcrumbLeaf: 'Moyenne par propriété par jour',
      },
      totalLeadsByProperty: {
        dashboardTitle: 'Total des prospects par propriété',
        routeTitle: 'Total des prospects par propriété',
        breadcrumbLeaf: 'Par propriété',
      },
      totalLeadsByPropertyType: {
        dashboardTitle: 'Total des prospects par type de propriété',
        routeTitle: 'Total des prospects par type de propriété',
        breadcrumbLeaf: 'Par type de propriété',
      },
      totalLeadsByCity: {
        dashboardTitle: 'Total des prospects par ville',
        routeTitle: 'Total des prospects par ville',
        breadcrumbLeaf: 'Par ville',
      },
      totalLeadsByCityPerProperty: {
        dashboardTitle: 'Moyenne de prospects par propriété par ville',
        routeTitle: 'Moyenne de prospects par propriété par ville',
        breadcrumbLeaf: 'Par ville par propriété',
      },
      totalLeadsBySourceProperty: {
        dashboardTitle: 'Moyenne de prospects par propriété active par source',
        routeTitle: 'Moyenne de prospects par propriété active par source',
        breadcrumbLeaf: 'Par propriété par source',
      },
      totalLeadsBySourceDay: {
        dashboardTitle: 'Par propriété par source par jour',
        routeTitle: 'Par propriété par source par jour',
        breadcrumbLeaf: 'Par propriété par source par jour',
      },
      siteLeadsBySource: {
        dashboardTitle: 'Prospects du site d\'annonces par source',
        routeTitle: 'Par source',
      },
      siteLeadsOverview: {
        dashboardTitle: 'Aperçu des prospects du site d\'annonces',
        routeTitle: 'Aperçu',
      },
      siteLeadsAdTrend: {
        dashboardTitle: 'Tendances récentes',
        routeTitle: 'Tendances récentes',
      },
      siteLeadsInfinity: {
        dashboardTitle: 'Prospects Infinity',
        routeTitle: 'Infinity',
      },
      leadsWebsiteOverview: {
        dashboardTitle: 'Aperçu des prospects du site web',
        routeTitle: 'Aperçu',
      },
      leadsWebsiteReferral: {
        dashboardTitle: 'Source de référence des prospects du site web',
        routeTitle: 'Sources de référence',
      },
      leadsWebsiteDevices: {
        dashboardTitle: 'Répartition du trafic du site web par appareil',
        routeTitle: 'Appareils du site web',
      },
      floorplanNavigator: {
        dashboardTitle: 'Navigateur de plans d\'étage',
        routeTitle: 'Navigateur de plans d\'étage',
      },
      leadsWebsiteCallReport: {
        dashboardTitle: 'Rapport d\'appels',
        routeTitle: 'Rapport d\'appels',
      },
      callTrackingOverview: {
        dashboardTitle: 'Aperçu du suivi des appels',
        routeTitle: 'Aperçu',
      },
      callTrackingCallsBySource: {
        dashboardTitle: 'Appels par source',
        routeTitle: 'Appels par source',
      },
      callTrackingCallsByProperty: {
        dashboardTitle: 'Appels par propriété',
        routeTitle: 'Appels par propriété',
      },
      callTrackingDuration: {
        dashboardTitle: 'Durée des appels',
        routeTitle: 'Durée des appels',
      },
      callTrackingUsage: {
        dashboardTitle: 'Utilisation de pointe',
        routeTitle: 'Utilisation de pointe',
      },
      tours: {
        dashboardTitle: 'Visites',
        routeTitle: 'Visites',
      },
      websitesLeads: {
        dashboardTitle: 'Aperçu du site web',
        routeTitle: 'Aperçu',
      },
      websitesTraffic: {
        dashboardTitle: 'Aperçu du trafic du site web',
        routeTitle: 'Trafic du site web',
      },
      websitesEvents: {
        dashboardTitle: 'Événements du site web',
        routeTitle: 'Événements du site web',
      },
      googleAds: {
        dashboardTitle: 'Google Ads',
        routeTitle: 'Google Ads',
      },
      listingScores: {
        dashboardTitle: 'Cotes des annonces',
        routeTitle: 'Cotes des annonces',
      },
      customReporting: {
        routeTitle: 'Rapports personnalisés',
      },
      listingEngagements: {
        dashboardTitle: 'Engagement des annonces',
        routeTitle: 'Engagement des annonces',
      },
    },

    titleBar: {
      exportToExcel: 'Exporter vers Excel',
      exportToPdf: 'Exporter vers PDF',
      filterReports: 'Filtrer les rapports ({count})',
      exportExcelSuccess: 'Exporté vers Excel.',
      exportExcelError: 'Erreur lors de l\'exportation vers Excel.',
    },

    sidebarFilters: {
      defaultTitle: 'Filtres',
      learnMore: 'En savoir plus',
      maxCount: '(Max {max})',
      selectedCountParens: '({count})',
      showMore: 'AFFICHER PLUS',
      reset: 'Réinitialiser',
      clear: 'Effacer',
      resetFilters: 'Réinitialiser les filtres',
      applyFilters: 'Appliquer les filtres',
      singleValueRequired: 'Une valeur est requise pour le filtrage!',
      multiValueRequired: 'Au moins une sélection est requise pour le filtrage!',
      lockedTooltip: 'Les filtres avancés sont disponibles uniquement avec un accès complet.',
      filtersAppliedCount: '({count} filtre appliqué) | ({count} filtres appliqués)',
    },

    filters: {
      dates: {
        label: 'Dates',
      },
      sources: {
        label: 'Sources',
      },
      buildings: {
        label: 'Propriétés',
      },
      propertyType: {
        label: 'Type de propriété',
      },
      cities: {
        label: 'Villes',
        helpText: 'Sélectionnez une ou plusieurs villes pour filtrer le rapport.',
      },
      websites: {
        label: 'Sites web actifs',
      },
      ownershipGroups: {
        label: 'Groupes de propriétaires',
      },
      agents: {
        label: 'Agents',
      },
      adCampaigns: {
        label: 'Campagnes publicitaires',
      },
      fpnSites: {
        label: 'FPN actifs',
      },
    },

    customReporting: {
      stats: {
        yearsTitle: '12+ ans',
        yearsSubtitle: 'Expérience dans l\'industrie',
        propertiesTitle: '22 000+',
        propertiesSubtitle: 'Propriétés actives',
        unitsTitle: '100 000+',
        unitsSubtitle: 'Unités actives',
        leadsTitle: '250 000+',
        leadsSubtitle: 'Prospects par mois',
        queriesTitle: '15 000 000+',
        queriesSubtitle: 'Requêtes par mois',
      },
      about: {
        title: 'À propos des rapports personnalisés de Rentsync',
        contentTitle: 'Suivre les tendances du marché multirésidentiel peut être long et complexe.',
        bodyParagraph1: 'Rentsync vise à vous permettre de comprendre rapidement et facilement où en sont les marchés et où ils se dirigent, grâce à nos rapports de données personnalisés sur le marché multirésidentiel et les locataires.',
        bodyParagraph2: 'Nous détenons une vaste collection de données multirésidentielles couvrant les conditions du marché, les nouvelles constructions, le trafic des locataires et plus encore, offrant les données les plus précises et détaillées pour votre analyse.',
        bodyParagraph3: 'Grâce à des graphiques faciles à lire et conçus sur mesure selon les indicateurs recherchés, et à l\'ajout de notre sommaire d\'analyse interne, chaque rapport est livré dans un format numérique téléchargeable, facile à lire et à partager avec votre équipe.',
        bodyParagraph4: 'Que vous construisiez une nouvelle propriété, mettiez à jour une propriété existante ou souhaitiez situer votre position sur le marché, les rapports personnalisés de Rentsync peuvent vous aider à prendre des décisions plus éclairées et à rester à l\'affût des tendances actuelles du marché.',
        bodyParagraph5: 'Tous les rapports sont offerts à l\'achat. Veuillez soumettre votre demande ci-dessous et un membre de l\'équipe Rentsync communiquera avec vous pour les prochaines étapes.',
      },
      reportTypesHeader: 'Types de rapports personnalisés',
      reportTypes: {
        leadReport: 'Rapport de prospects',
        rentersInsightReport: 'Rapport d\'analyse des locataires',
        marketSurveyReport: 'Rapport d\'enquête de marché',
        marketComparisonReport: 'Rapport de comparaison de marché',
        fullCustomReport: 'Rapport entièrement personnalisé',
      },
      requestReportButton: 'Demander un rapport',
    },
  },
} as const;
